import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Index from './components/Index';
import Service from './components/Service';
import Nails from './components/Nails';
import Hair from './components/Hair';
import Lash from './components/Lash';
import Waxing from './components/Waxing';
import Skincaretreatment from './components/Skincaretreatment';
import Aboutus from "./components/Aboutus";
import Gallery from './components/Gallery';
import Contactus from './components/Contactus';
import OurMission from './components/OurMission';
import OurStory from './components/OurStory';
import MeettheTeam from './components/MeettheTeam';
import Booking from './components/Booking';
import PromotionsGiftcards from './components/PromotionsGiftcards';
import Login from './components/Login';
import Registration from './components/Registration';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/Service" element={<Service />} />
          <Route path="/NailsService" element={<Nails />} />
          <Route path='/HairService' element={<Hair />} />
          <Route path='/LashService' element={<Lash />} />
          <Route path='/WaxingService' element={<Waxing />} />
          <Route path='/SkincareService' element={<Skincaretreatment />} />
          <Route path='/Aboutus' element={<Aboutus />} />
          <Route path='/Gallery' element={<Gallery />} />
          <Route path='/Contactus' element={<Contactus />} />
          <Route path='/OurMission' element={<OurMission />} />
          <Route path='/OurStory' element={<OurStory />} />
          <Route path='/MeettheTeam' element={<MeettheTeam />} />
          <Route path='/Booking' element={<Booking />} />
          <Route path='/PromotionsGiftcards' element={<PromotionsGiftcards />} />
          <Route path='/Login' element={<Login />} />
          <Route path='/Registration' element={<Registration />} />

        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
